import { ApplicationContext } from "../Provider/ApplicationProvider";
import React, { useContext, useEffect, useState } from "react";
import Card2 from "./Card2";
import { Ajax } from "../Service/ajax";
import PricingCard from "./PricingCard";
import PricingCard2 from "./PricingCard2";

export default function SubscriptionSection({ subscriptions, cmp, user=false, categories, category, setCategory }) {

    async function loadConversion(amount) {
        try {
            const { data } = await Ajax.getRequest(`/exposed/v1/loc/conversion-rates/convert`, {
                params: {
                    origin: "CDF",
                    target: "USD",
                    amount: amount
                }
            });

            return data?.converted_amount ? parseFloat(data.converted_amount.toFixed(2)) : null;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    function trierListe(liste) {
        liste.sort((a, b) => {
            if (a.devise === "USD" && b.devise !== "USD") {
                return -1;
            } else if (a.devise !== "USD" && b.devise === "USD") {
                return 1;
            } else {
                return 0;
            }
        });

        liste.sort((a, b) => {
            if (a.devise === b.devise) {
                return a.price - b.price;
            }
            return 0;
        });

        return liste;
    }


    const sortedSubscriptions = trierListe(subscriptions);
    const { findLargestOptionsSize } = useContext(ApplicationContext);
    const maxSize = findLargestOptionsSize(subscriptions);



    // **État local pour stocker les conversions**
    const [convertedPrices, setConvertedPrices] = useState({});

    useEffect(() => {
        console.log(user);
        async function fetchConversions() {
            let conversions = {};
            for (let item of sortedSubscriptions) {
                if (item.currency === "CDF") {
                    conversions[item.id] = await loadConversion(item.price);
                }
            }
            setConvertedPrices(conversions);
        }
        fetchConversions();
    }, [subscriptions]); // Recharger quand les abonnements changent

    return (
        <div>
            <div className="divider pb-1 mb-4">
                <div className="divider-text display-5">
                    <h5 className="display-6">Tarifications</h5>
                </div>
            </div>
            {categories.length > 1 && (
                <div className="d-flex flex-column align-items-center justify-content-center text-center mb-4">
                    {/* Titre descriptif */}
                    <div className="mb-3">
                        <p className="fs-5 fw-bold">
                            Choisissez la catégorie d'abonnement qui correspond le mieux à vos besoins.
                        </p>
                    </div>

                    {/* Boutons radio */}
                    <div className="btn-group" role="group" aria-label="Type de transaction">
                        {categories.map((cat, index) => (
                            <React.Fragment key={cat}>
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="btnradioType"
                                    id={`btnradio-${cat}`}
                                    value={category}
                                    onChange={() =>  setCategory(cat)}
                                    checked={cat === category}
                                />
                                <label className="btn btn-outline-netikash" htmlFor={`btnradio-${cat}`}>
                                    {cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase()}
                                </label>
                            </React.Fragment>
                        ))}
                    </div>

                </div>
            )}
            <div className={"mb-5"}>
                {user ?  <>
                        {sortedSubscriptions.some(item => item.currency === "USD" && item.category === category) && (
                            <div className="row mb-5 justify-content-center">
                                {sortedSubscriptions
                                    .filter(item => item.currency === "USD" && item.category === category)
                                    .map((item) => (
                                        <Card2
                                            key={item.id}
                                            devise={item.currency}
                                            title={item.title}
                                            periodicity={item.periodicity}
                                            description={"Détails du pack"}
                                            price={item.price}
                                            options={item.options}
                                            max={maxSize}
                                            subscription={item}
                                            cmp={cmp}
                                        />
                                    ))}
                            </div>
                        )}

                        {sortedSubscriptions.some(item => item.currency === "CDF" && item.category === category) && (
                            <div className="row mb-5 justify-content-center">
                                {sortedSubscriptions
                                    .filter(item => item.currency === "CDF" && item.category === category)
                                    .map((item) => (
                                        <Card2
                                            key={item.id}
                                            devise={item.currency}
                                            title={item.title}
                                            periodicity={item.periodicity}
                                            description={"Détails du pack"}
                                            price={item.price}
                                            options={item.options}
                                            max={maxSize}
                                            subscription={item}
                                            cmp={cmp}
                                            convertedAmount={convertedPrices[item.id]}
                                        />
                                    ))}
                            </div>
                        )}
                    </>
                    :
                    <div className="row g-6 pt-lg-5">
                        <div className="col-xl-6 col-lg-6 mb-4">
                            <PricingCard2 subscriptions={subscriptions} />
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <PricingCard subscriptions={subscriptions} />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}
